import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Header';
import EmployeeDemo from "./EmployeeDemo";
import DataPullDashboard from "./DataPullDashboard";

const APIManagement = () => {



  return (
    <>
      <Header icon={"fa-solid fa-users fa-xl mx-2"}  label={"Admin/API Management"} />
      <main id="main" className="main">
        <section className="section ">
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
              <div className='card'>

                <div className='card-body'>
                  <DataPullDashboard />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}
export default APIManagement;
